import {
  faCheck,
  faPenToSquare,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Card, Col, Form, Row, Table } from "react-bootstrap";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import EditSettingModel from "../../../../components/Modal/EditSetting.modal";
import AdminService from "../../../../services/admin.service";
import ExamService from "../../../../services/exam.service";
import ExamDetails from "./ExamDetails/ExamDetails";

const ExamById = () => {
  const params = useParams();

  const [exam, setExam] = useState<any>();
  const [enumsData, setEnumsData] = useState<any>();
  const [examSetting, setExamSetting] = useState<any>();
  const [showEditModal, setShowEditModal] = useState<any>(false);
  const [toggleExamOffline, setToggleExamOffline] = useState<boolean>(false);
  const [settingValue, setSettingValue] = useState<any>([]);

  const handleCheckedValue = (e: any, enum_type: string) => {
    const old_settingValue = settingValue;
    const rem_settings = old_settingValue.filter(
      (setting: any) => setting.method != enum_type
    );
    let current_enum = old_settingValue.find(
      (setting: any) => setting.method == enum_type
    );
    if (!current_enum) {
      current_enum = {
        method: enum_type,
        [e.target.name]: e.target.checked,
      };
    } else {
      current_enum = { ...current_enum, [e.target.name]: e.target.checked };
    }
    setSettingValue([...rem_settings, current_enum]);
  };

  const updateSetting = async () => {
    await AdminService.updateSettings(params.examId, settingValue)
      .then((res) => {
        if (res.status === 200) {
          toast.success("Exam setting update successfully");
        }
        setShowEditModal(false);
        getExamSetting();
      })
      .catch((err) => {
        toast.error("Unable to update exam settings..");
      });
  };

  const getAllExamById = async () => {
    await ExamService.getAllExamById(params.examId)
      .then((res) => {
        if (res.status === 200) {
          setExam(res.data.data.exam);
          setToggleExamOffline(res.data.data.exam?.offlineMode || false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllEnums = async () => {
    await AdminService.getAllEnumsForVerification()
      .then((res) => {
        if (res.status === 200) {
          setEnumsData(res.data.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getExamSetting = async () => {
    await AdminService.getExamSetting(params.examId)
      .then((res) => {
        if (res.status === 200) {
          setExamSetting(res.data.data.settings);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleToggleExamOffline = async () => {
    await AdminService.toggleExamOffline(params.examId)
      .then((res) => {
        if (res.status === 200) {
          // setToggleExamOffline(true);
          toast.success("Success");
          getAllExamById();
        }
      })
      .catch((err) => {
        toast.error(err.response.data);
        setToggleExamOffline(false);
      });
  };

  const createApiKey = async () => {
      await ExamService.createApiKey(params.examId)
      .then((res) => {
        if(res.status === 200){
          toast.success("API Key Created Successfully");
          getAllExamById();
        }
      }).catch((err) => {
        toast.error("Unable to create API Key");
      })
  }

  useEffect(() => {
    getAllExamById();
    getAllEnums();
    getExamSetting();
  }, []);

  return (
    <>
      <Card className="bio-card mt-4">
        <Card.Body>
          <div className="d-flex align-items-center justify-content-between">
            <h6 className="text-muted fw-bold">Exam: {exam && exam.name}</h6>
            <Form.Group className="d-flex align-items-center">
              <Form.Label className="fw-bold text-muted">Offline</Form.Label>
              <Form.Switch
                className="mb-2 ms-3"
                checked={toggleExamOffline}
                onClick={handleToggleExamOffline}
              />
            </Form.Group>
          </div>
          <hr className="text-muted" />
          <Row>
            <Col md={3}>
              <div className="mt-3">
                <div className="d-flex justify-content-between">
                  <p className="fw-bold xcn-text-14">Auth Settings</p>
                  <FontAwesomeIcon
                    icon={faPenToSquare}
                    className="text-muted ms-1 mt-1 xcn-text-14 xcn-link-pointer"
                    onClick={() => {
                      setShowEditModal(true);
                    }}
                  />
                </div>
                <div>
                  <Table striped hover className="xcn-text-12">
                    <thead>
                      <tr>
                        <th>
                          <span className="fw-bold text-muted">Auth Type</span>
                        </th>

                        <th>
                          <span className="fw-bold text-muted">Allowed</span>
                        </th>

                        <th>
                          <span className="fw-bold text-muted">Required</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {enumsData && enumsData.length > 0
                        ? enumsData.map((data: any) => {
                          const enum_val = examSetting?.find(
                            (setting: any) => setting.method == data
                          );
                          return (
                            <tr>
                              <td>
                                <span className="fw-bold text-capitalize">
                                  {data === "fingerprint"
                                    ? "Right Fingerprint"
                                    : data === "fingerprint2"
                                      ? "Left Fingerprint"
                                      : data}
                                </span>
                              </td>
                              <td>
                                {enum_val && enum_val.allowed ? (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    color="green"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    icon={faXmark}
                                    color="red"
                                  />
                                )}
                              </td>
                              <td>
                                {enum_val && enum_val.forceRequired ? (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    color="green"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    icon={faXmark}
                                    color="red"
                                  />
                                )}
                              </td>
                            </tr>
                          );
                        })
                        : "No Data"}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Col>
            <Col md={9}>
              <ExamDetails exam={exam} refreshExam={getAllExamById} />
            </Col>
          </Row>

        </Card.Body>
      </Card>
      <EditSettingModel
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        enumsData={enumsData}
        settings={examSetting}
        handleValue={handleCheckedValue}
        handleSubmission={updateSetting}
      />
    </>
  );
};

export default ExamById;
